import { UserCircle, Smiley, CalendarBlank, SlidersHorizontal, PersonArmsSpread } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../../library/LibraryPrimitives";
import { AreaNode } from "../diagrams";

const A11Y = ["Read-aloud audio", "Reduced motion", "Larger text", "High contrast", "Dyslexia-friendly font"];

export function ProfileSection() {
  return (
    <SectionShell
      id="profile"
      eyebrow="Profile"
      eyebrowIcon={UserCircle}
      title="Made theirs, made accessible"
      description="Profile gives children a sense of ownership and gives the whole experience its settings. Crucially, the chosen Year Group quietly tunes age adaptation everywhere."
    >
      <div className="space-y-8">
        <Showcase title="What's in a profile" tone="muted">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <AreaNode icon={Smiley} label="Avatar" purpose="A friendly self to grow" tone="orange" />
            <AreaNode icon={CalendarBlank} label="Year Group" purpose="Drives age adaptation" tone="blue" />
            <AreaNode icon={SlidersHorizontal} label="Preferences" purpose="Subjects, sounds, theme" tone="teal" />
            <AreaNode icon={PersonArmsSpread} label="Accessibility" purpose="Comfort for every child" tone="yellow" />
          </div>
        </Showcase>

        <div className="grid gap-5 lg:grid-cols-2">
          <div className="rounded-3xl border border-border bg-card p-6 shadow-soft">
            <p className="text-sm font-bold uppercase tracking-wider text-muted-foreground">Accessibility settings</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {A11Y.map((a) => (
                <span key={a} className="rounded-full bg-muted px-3 py-1.5 text-sm font-bold text-foreground">{a}</span>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-3xl border border-border bg-accent/50 p-6">
            <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-primary text-primary-foreground"><CalendarBlank size={24} weight="fill" /></span>
            <p className="font-medium text-foreground"><strong>Year Group is the master dial.</strong> Setting it once adapts touch sizes, illustration density, audio support, motion and reading level across every area.</p>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}

export default ProfileSection;
